module.exports = __webpack_public_path__ + "static/BOT-5fe5c321bd430c9fcdf4c345e9930acb.gif";